import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../common/state/store";

interface IGraphViewState {
  projectId: number | null;
  scale: number;
  translateX: number;
  translateY: number;
}

const initialState: IGraphViewState = {
  projectId: null,
  scale: 1,
  translateX: 0,
  translateY: 0,
};

export const graphViewSlice = createSlice({
  name: "graphView",
  initialState,
  reducers: {
    setGraphView: (state, action: PayloadAction<IGraphViewState>) => {
      state.projectId = action.payload.projectId;
      state.scale = action.payload.scale;
      state.translateX = action.payload.translateX;
      state.translateY = action.payload.translateY;
    },
    resetGraphView: () => initialState,
  },
});

export const { setGraphView, resetGraphView } = graphViewSlice.actions;

export const getGraphView = (state: RootState) => state.graphView;

export default graphViewSlice.reducer;
